/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectTaskRef } from './projectTaskRef';
import { Milestone } from './milestone';
import { CommunicationData } from './communicationData';
import { CompanyBrandRef } from './companyBrandRef';
import { TaskAnnotationStatus } from './taskAnnotationStatus';
import { TeamRef } from './teamRef';
import { Workflow } from './workflow';
import { UserInfo } from './userInfo';
import { ProjectRef } from './projectRef';
import { CompanyRef } from './companyRef';


export interface Task { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    description?: string;
    taskTypeId?: string;
    taskType?: string;
    isOnCriticalPath?: boolean;
    currentlyWithUser?: UserInfo;
    currentlyWithTeam: TeamRef;
    currentStepId?: number;
    lastStepId?: number;
    status?: string;
    taskDuration?: number;
    startDate: string;
    deadline: string;
    parentStartDate?: string;
    parentDeadline?: string;
    nextDueDate?: string;
    project: ProjectRef;
    parentProjectId: string;
    parentTaskId?: ProjectTaskRef;
    parentRefIds: Array<string>;
    childIds?: Array<ProjectTaskRef>;
    communication?: Array<CommunicationData>;
    annotationStatus?: Array<TaskAnnotationStatus>;
    parentId?: ProjectTaskRef;
    agency: CompanyRef;
    client: CompanyRef;
    brand: CompanyBrandRef;
    accessKeys: Array<string>;
    mileStones?: Array<Milestone>;
    assets?: Array<string>;
    mainAssetId?: string;
    resetMainAssetFlag?: boolean;
    workflow?: Workflow;
    childsStatus?: boolean;
    milestoneUpdatedFlag?: boolean;
    /**
     * I am following this task to get notifications
     */
    following: boolean;
    /**
     * to fetch the duration of current step
     */
    currentStepDuration?: number;
    /**
     * to fetch the duration of next WIP progress step
     */
    wipStepDuration?: number;
    timeZoneOffset?: number;
}

